import { useEffect, useState, useRef } from 'react';

type TProps = {
  timeout?: number;
};

const useInactivityDetect = ({ timeout = 5000 }: TProps = {}) => {
  const [isActive, setIsActive] = useState<boolean>(true);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleUserActivity = () => {
      if (!isActive) {
        setIsActive(true);
      }
      resetTimer();
    };

    const handleInactivity = () => {
      setIsActive(false);
    };

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(handleInactivity, timeout);
    };

    const events: string[] = ['mousemove', 'keydown', 'scroll', 'click'];

    events.forEach((event) =>
      window.addEventListener(event, handleUserActivity)
    );

    resetTimer(); // Initialize the timer on hook mount

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) =>
        window.removeEventListener(event, handleUserActivity)
      );
    };
  }, [isActive, timeout]);

  return isActive;
};

export default useInactivityDetect;
